var _env;
var _config;

export const get = (key) => {
    if (!_config) setup(false);
    return _config[key];
};

export const getEnv = () => process.env.NEXT_PUBLIC_ENV ?? 'prd';

const getEnvByARN = (ctx) => {
    return ctx.invokedFunctionArn.slice(-3);
};

export const setup = (ctx) => {
    if (ctx && ctx.invokedFunctionArn) _env = getEnvByARN(ctx);
    else _env = getEnv();
    _config = require(`./config.${_env}.json`);
};
